import { Box } from '@mui/material';

export const Image = ({ src, alt, sx, ...props }) => {
  return (
    <Box sx={sx} {...props}>
      <Box component="img" sx={{ width: '100%', height: '100%' }} src={src} alt={alt || 'Image'} />
    </Box>
  );
};
